<script>
  import {
    flow_steps,
    dbClearAllInvalidItems,
    clearAllInvalidItems,
    invalidateItem,
    user_data,
    parseCityStateZip,
    userNotification,
  } from "../stores.js";
  import * as yup from "yup";
  import { debounce } from "lodash";
  import { slide } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  import { link, location, push, pop, replace } from "svelte-spa-router";
  import CTA from "./ctacomponent.svelte";
  import FooterComponent from "./servicesfootercomponent.svelte";
  import AddressComponent from "./addresscomponent.svelte";
  // import { GooglePlacesAutocomplete } from '@beyonk/svelte-googlemaps'
  // export let step_info = "landing";

  export let progress_mobile_version = true;
  let mobile_menu_open = "";
  let show_dropdown = false;
  let show_searching_indicator = true;

  // let current_address;

  // function doPlaceChanged(evt){
  //     console.log("... doing placechange")
  //     console.log(evt);
  // }

  function toggleMobileMenu() {
    if (mobile_menu_open === "open") {
      mobile_menu_open = "";
    } else {
      mobile_menu_open = "open";
    }
  }

  let dropdown_shown = "";
  function toggleLinkList(ds) {
    closeLinkList();
    if (ds === "") {
        dropdown_shown = "shown";
    } else {
      dropdown_shown = "";
    }
  }
  function closeLinkList() {
    if (dropdown_shown === "shown") {
      dropdown_shown = "";
    }
    if (resource_dropdown_shown === "shown") {
      resource_dropdown_shown = "";
    }
    if (services_dropdown_shown === "shown") {
      services_dropdown_shown = "";
    }
  }

  let resource_dropdown_shown = "";
  function toggleResourceLinkList(rds) {
    closeLinkList();
    if (rds === "") {
      resource_dropdown_shown = "shown";
    } else {
      resource_dropdown_shown = "";
    }
  }

  let services_dropdown_shown = "";
  function toggleServicesLinkList(sds) {
    closeLinkList();
    if (sds === "") {
      services_dropdown_shown = "shown";
    } else {
      services_dropdown_shown = "";
    }
  }


   
</script>

<div
  class="maincontainer  {progress_mobile_version
    ? 'maincontainerprogressmobile'
    : ''}"
>
  <div
    on:click|self={() => {
      closeLinkList();
    }}
    class="topcontainer {progress_mobile_version
      ? 'topcontainerprogressmobile'
      : ''}"
  >
    <div
      class="navmobilecontainer {progress_mobile_version
        ? 'navmobilecontainerprogressmobile'
        : ''}"
    >
      <div class="logocontainer">
        <a href="/"
          ><img
            src="/img/HomeEasy_logo_dark_grey-01.png"
            alt="Semper Home Loans Logo"
          /></a
        >
      </div>
      <div class="hamburgermenucontainer">
        <div class="hamburgermenuholder">
          <div
            on:click={() => {
              toggleMobileMenu();
            }}
            class="hamburgermenu {mobile_menu_open}"
          >
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
        <div
          transition:slide={{ delay: 250, duration: 300, easing: quintOut }}
          class="mobilemenucontainer {mobile_menu_open === 'open'
            ? ''
            : 'closedmenu'}"
        >
          <div class="navlink">
            <a href="/#/real_estate_services"
              >Real estate services</a
            >
          </div>
          <div class="navlink">
            <a href="/#/title_insurance_services_page"
              >Title insurance services</a
            >
          </div>
          <div class="navlink">
            <a href="/#/homeowners_insurance_services_page"
              >Homeowner's insurance services</a
            >
          </div>
          <div class="navlink">
            <a href="/"
              >Mortgage</a
            >
          </div>

          <div class="navlink">
            <!-- <a href={null} on:click|preventDefault={() => {gtag_event('view_purchase_rates', 'button_click', 'Rate Table Site', '/#/dfp_process_status?p=8&f=drp&b=1&n=3');}}>View purchase rates</a> -->

          </div>

          <div class="navlink">
            <!-- <a href={null} on:click|preventDefault={() => {gtag_event('view_refi_rates', 'button_click', 'Rate Table Site', '/#/dfr_financing_goal?p=8&f=drr&b=1&n=3');}}>View refinance rates</a> -->
          </div>
          <div class="navlink">
            <a href="https://asksemper.zendesk.com/hc/en-us">Support Center</a>
          </div>

          <div class="navlink">
            <a href="https://semperhomeloans.com/application-faq/">FAQ</a>
          </div>
          <div class="navlink">
            <a href="/homeeasy/index.html">Process</a>
          </div>

          <!-- <div class="numbercontainer navlink"> -->
          <!-- <div class="phoneiconcontainer"><img src="/img/Phone_contact.svg" alt="Semper Home Loans Logo"> -->
          <!-- </div> -->
          <!-- <div class="phonenumber"><a href="tel:866-528-3814">(866) 528-3814</a></div> -->
          <!-- </div> -->

          <div class="navlink">
            <a href="https://homeeasy.semperhl.com/login">Sign in</a>
          </div>

          <div class="mobileapplynowbuttoncontainer">
            <a
              href="https://homeeasy.semperhl.com/homehub/signup/ASKSEMPER@SEMPERHL.COM"
              >Apply now</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      on:click|self={() => {
        closeLinkList();
      }}
      class="navcontainer"
    >
      <div class="logocontainer">
        <a href="/"
          ><img
            src="/img/HomeEasy_logo_dark_grey-01.png"
            alt="Semper Home Loans Logo"
          /></a
        >
      </div>
      <div class="navlinkscontainer">
        <!-- <div class="navlink">
                    <a href="https://semperhomeloans.com/applications/process/">Our Process</a>
                </div> -->
        <div class="navlink viewrateslinkcontainer">
          <a
            class="viewrateslink {services_dropdown_shown}"
            href={null} on:click|preventDefault={() => {
              toggleServicesLinkList(services_dropdown_shown);
            }}>Our services</a
          >
          <div class="dropdown-content {services_dropdown_shown}">
            <div class="dclinkcontainer">
              <button
                onclick="window.location.href='/#/real_estate_services'"
                >Real estate</button
              >
            </div>
            <div class="dclinkcontainer">
              <button
                onclick="window.location.href='/#/title_insurance_services_page'"
                >Title insurance</button
              >
            </div>
            <div class="dclinkcontainer">
                <button onclick="window.location.href='/#/homeowners_insurance_services_page'"
                  >Homeowner's insurance</button
                >
              </div>
              <div class="dclinkcontainer">
                <button onclick="window.location.href='/'"
                  >Mortgage</button
                >
              </div>
            </div>
          <!-- <a href="https://asksemper.zendesk.com/hc/en-us">Resources</a> -->
        </div>

        <div class="navlink viewrateslinkcontainer">
          <a
            class="viewrateslink {dropdown_shown}"
            href={null} on:click|preventDefault={() => {
              toggleLinkList(dropdown_shown);
            }}>View rates</a
          >
          <div class="dropdown-content {dropdown_shown}">
            <div class="dclinkcontainer">
              <!-- <button on:click={()=>{gtag_event('view_purchase_rates', 'button_click', 'Rate Table Site', '/#/dfp_process_status?p=8&f=drp&b=1&n=3');}} >Purchase</button> -->

              <!-- <a href="#/dfp_process_status?p=8&f=drp&b=1&n=3">Purchase</a> -->
            </div>
            <div class="dclinkcontainer">
              <!-- <button on:click={()=>{gtag_event('view_refi_rates', 'button_click', 'Rate Table Site', '/#/dfr_financing_goal?p=8&f=drr&b=1&n=3');}} >Refinance</button> -->

              <!-- <a href="#/dfr_financing_goal?p=8&f=drr&b=1&n=3">Refinance</a> -->
            </div>
          </div>
        </div>

        <div class="navlink viewrateslinkcontainer">
          <a
            class="viewrateslink {resource_dropdown_shown}"
            href={null} on:click|preventDefault={() => {
              toggleResourceLinkList(resource_dropdown_shown);
            }}>Resources</a
          >
          <div class="dropdown-content {resource_dropdown_shown}">
            <div class="dclinkcontainer">
              <button
                onclick="window.location.href='https://asksemper.zendesk.com/hc/en-us'"
                >Support Center</button
              >
              <!-- <a href="#/dfp_process_status?p=8&f=drp&b=1&n=3">Purchase</a> -->
            </div>
            <div class="dclinkcontainer">
              <button
                onclick="window.location.href='https://semperhomeloans.com/application-faq/'"
                >FAQ</button
              >
              <!-- <a href="#/dfr_financing_goal?p=8&f=drr&b=1&n=3">Refinance</a> -->
            </div>
            <div class="dclinkcontainer">
              <button onclick="window.location.href='/homeeasy/index.html'"
                >Process</button
              >
              <!-- <a href="#/dfr_financing_goal?p=8&f=drr&b=1&n=3">Refinance</a> -->
            </div>
          </div>
          <!-- <a href="https://asksemper.zendesk.com/hc/en-us">Resources</a> -->
        </div>

        <!-- <div class="navlink"> -->
        <!-- <a href="tel:+8665283814">(866) 528-3814</a> -->
        <!-- </div> -->
        <!-- <div class="navlink">
                    <a href="https://homeeasy.semperhl.com/login">Sign in</a>
                </div> -->
      </div>
      <div class="rightnavcontainer">
        <div class="navlink">
          <a href="https://homeeasy.semperhl.com/login">Sign in</a>
        </div>
        <div class="navbuttoncontainer">
          <button
            class="darken"
            on:click={() => {
              // gtag_event('apply_now', 'button_click', 'Rate Table Site', 'https://homeeasy.semperhl.com/homehub/signup/ASKSEMPER@SEMPERHL.COM');
            }}>Apply Now</button
          >
        </div>
      </div>
    </div>
    <!-- <div -->
      <!-- class="stepcontainer {progress_mobile_version -->
        <!-- ? 'stepcontainerprogressmobile' -->
        <!-- : ''}" -->
    <!-- > -->
      <!-- <slot> -->
       
      <!-- </slot> -->
      <!-- {#if step_info === "landing"} -->

      <!-- {:else} -->
      <!-- {/if} -->
    <!-- </div> -->


    <div class="topservice">
        <slot name="top_service">
            <div class="topserviceplaceholder">Top service</div>
        </slot>
    </div>
    <div class="bottomservice">
        <!-- <div class="bottomservicecontainer"> -->
            <slot name="bottom_service">
                <div class="bottomserviceplaceholder">Bottom service</div>
            </slot>    
        <!-- </div> -->
    </div>
    
</div>




  <div class="footercontainer">
    <FooterComponent />
  </div>

  <div class="mobileholder">Would be switching to mobile layout here.</div>
</div>

<style>
  .maincontainer {
      background-color: white;
    width: 100vw;
    min-width: 1240px;
    /* padding: 10px; */
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 20px; */
    /* background-color: white; */
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-template-areas:
      "tc tc tc tc tc tc tc tc tc tc tc tc"
      "bc bc bc bc bc bc bc bc bc bc bc bc"
      "sc sc sc sc sc sc sc sc sc sc sc sc"
      "fc fc fc fc fc fc fc fc fc fc fc fc";
    gap: 20px;
  }

  .topcontainer {
      width: 90%;
      max-width: 1400px;
      min-width: 1240px;
      margin-left: auto;
      margin-right: auto;
    grid-area: tc;
    /* background-image: url(/img/header_image2.png); */
    background-repeat: no-repeat;
    /* min-height: 700px; */
    /* max-height: 700px; */
    /* height: 52vw; */
    height: auto;
    /* width: 100vw; */
    background-position: 0% 0%;
    background-size: 100% 100%;
    background-color: white;
    position: relative;
  }

  .navmobilecontainer {
    display: none;
  }
  .navcontainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .logocontainer img {
    height: 36px;
  }
  .navlinkscontainer {
    display: flex;
    flex-direction: row;
    margin-left: 73.1484px;
  }

  .navlink a:hover,
  .navlink a:focus {
    /* font-weight: bold; */
    /* padding-left: 10px; */
    /* padding-right: 10px; */
    /* padding-top: 10px; */
    /* padding-bottom: 10px; */
    /* font-weight:700; */
    /* font-size: 1em; */
    /* color: var(--darkgray); */
    /* background-color: transparent; */
    /* border: solid 1.75px; */
    /* border-color: white; */
    /* border-radius: 5px; */
    cursor: pointer;
    text-decoration: underline;
    /* transition: all 100ms ease-in-out;  */
  }

  .navlink a {
    color: var(--linkcolordark);
    font-size: 1em;
    font-weight: 500;
    text-decoration: none;
    margin-left: 25px;
    transition: all 500ms linear;
  }

  .rightnavcontainer {
    display: flex;
    align-items: center;
  }

  .navbuttoncontainer {
    margin-left: 20px;
  }

  .navbuttoncontainer button {
    display: inline-block;
    /* line-height: 50px; */
    text-align: center;
    vertical-align: middle;
    /* height: 64px; */
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-weight: 700;
    font-size: 1em;
    /* color: var(--darkgray); */
    color: white;
    background-color: var(--semperred);
    /* border-style: solid; */
    border-width: 0px;
    /* border-color: white; */
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.25s linear;
    box-sizing: border-box;
  }

  /* .navbuttoncontainer button:hover { */
    /* border-color: var(--semperred); */
    /* color: white; */
    /* background-color: var(--semperred); */
    /* border-width: 2px; */
    /* font-weight: 900; */
    /* transition: all 0.25s linear; */
  /* } */

  .viewrateslinkcontainer {
    position: relative;
  }
  .viewrateslink:hover,
  .viewrateslink:link,
  .viewrateslink:active {
    text-decoration: none !important;
  }
  .viewrateslink::after {
    display: inline-block;
    content: " ";
    background-image: url("/img/Down_arrow_dark-01.svg");
    background-size: 10px 10px;
    height: 10px;
    width: 10px;
    /* content: '\2228'; */
    color: #ebebec !important;
    margin-left: 5px;
    transition: all 0.5s linear;
  }
  /* [class="viewrateslink shown"]:after { 
    content: '\2227';
    color: white;
    margin-left: 3px;
}
[class="shown viewrateslink"]:after { 
    content: '\2227';
    color: white;
    margin-left: 3px;
} */
  .viewrateslink.shown::after {
    /* content: '\2227';
    color: #ebebec !important;
    margin-left: 5px; */
    transform: rotate(-180deg);
  }

  .dropdown-content {
    /* display: none; */
    visibility: hidden;
    opacity: 0;
    position: absolute;
    background-color: white;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 5px;
    margin-top: 20px;
    padding: 5px;
    box-sizing: border-box;
    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
  }
  .dropdown-content.shown {
    /* display: block; */
    visibility: visible;
    opacity: 1;
    /* transform: translate(0, -20px); */
    /* transform: translate(-50%, 25px); */
    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
  }
  .dclinkcontainer {
    /* padding-top: 20px; */
    /* padding-bottom: 20px; */
    width: 100%;
  }
  /* .dclinkcontainer:hover {
    background-color: #ebebec;
    cursor: pointer;
} */
  .dclinkcontainer button {
    width: 100%;
    height: 100%;
    border: none;
    text-align: left !important;
    background-color: white;
    color: #343d50 !important;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    cursor: pointer;
  }
  .dclinkcontainer button:hover {
    background-color: #ebebec;
  }
  /* .dropdown-content a{
    color: #343d50 !important;
    width: 100%;
    height: 100%;
}
.dropdown-content a:link {
  text-decoration: none;
}

.dropdown-content a:visited {
  text-decoration: none;
}

.dropdown-content a:hover {
  text-decoration: none;
  background-color: #ebebec;
}

.dropdown-content a:active {
  text-decoration: none;
} */

.topservice {
    width: 100%;
}
.topserviceplaceholder {
    width: 100%;
    height: 100px;
    background-color: red;
}
.bottomservice {
    /* width: 100%; */
    background-color: var(--eclipse);
    width: 100vw;/* <-- children as wide as the browser window (viewport) */
    margin-left: calc(-1 * ((100vw - 100%) / 2));/* align left edge to the left edge of the viewport */

}
/* .bottomservicecontainer { */
    /* width: 90%; */
    /* max-width: 1400px; */
    /* min-width: 1240px; */
    /* margin-left: auto; */
    /* margin-right: auto; */
    
/* } */
.bottomserviceplaceholder {
    width: 100%;
    height: 100px;
    background-color: blue;
}

  .stepcontainer {
    width: 50%;
    height: 200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 80px;
    /* background-color: white; */
  }
  .cszinputcontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .csztitlecontainer,
  .csztextcontainer,
  .cszconditionscontainer {
    width: 100%;
    text-align: center;
    font-weight: 600;
    color: white;
    font-size: 2em;
    margin-top: 25px;
  }
  .csztitlecontainer {
    font-size: 3em;
    max-width: 450px;
    margin-bottom: 40px;
    color: white;
  }
  .csztextcontainer,
  .cszconditionscontainer {
    font-weight: normal;
    font-size: 1em;
    color: var(--blueslate);
  }
  .cszinputfieldcontainer {
    background-color: white;
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    padding-top: 60px;
    padding-bottom: 80px;
  }
  .csztopcopy {
    width: 100%;
    font-size: 1.25em;
  }
  .cszbottomcopy {
    width: 100%;
    display: flex;
    align-items: center;
    color: #657680;
    margin-top: 20px;
  }
  .cbcheadphones {
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }
  .cbcheadphones img {
    width: 100%;
    height: 100%;
  }
  .cszbottomcopy a {
    color: #657680 !important;
    margin-left: 5px;
  }
  .cszfieldcontainer {
    width: 100%;
    /* margin-left: auto; */
    /* margin-right: auto; */
    padding: 0px;
    display: flex;
    position: relative;
    flex-direction: row;
    /* justify-content: center; */
    align-items: center;
    margin-top: 25px;
  }
  /* .fieldsearchbusy {
    z-index: 999;
    position: absolute;
    top: 0px;
    width: 24px;
    height: 24px;
}
.fieldsearchbusy img {
    width: 100%;
    height: 100%;
} */
  .searchingplaceholder {
    width: 100%;
    padding: 0px;
    display: flex;
  }
  .searchingplaceholdertext {
    color: var(--semperred);
    font-weight: bold;
    font-size: 1em;
  }
  .searchingplaceholderindicator {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .searchingplaceholderindicator img {
    width: 25%;
  }
  .dropdownsearchcontainer {
    z-index: 999;
    position: absolute;
    top: 50px;
    margin-left: auto;
    margin-right: auto;
    /* display: flex; */
    /* flex-direction: column; */
    width: 300px;
    max-height: 150px;
    background-color: white;
    overflow-y: scroll;
    box-sizing: border-box;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    border-right: 1px solid;
    border-color: var(--placeholdergray);
  }
  .dropdownsearchcontainer button {
    border: none;
    border-radius: 0px !important;
    /* border-bottom-right-radius: 0px !important; */
    background-color: white !important;
    color: var(--placeholdergray) !important;
    height: 40px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-align: left !important;
    margin-left: 0px !important;
  }
  .dropdownsearchcontainer button:hover {
    color: white !important;
    background-color: var(--placeholdergray) !important;
  }
  .dropdownsearchcontainer button:not(:last-of-type) {
    border-bottom: 1px solid #ccc;
  }

  .cszfieldcontainer button {
    height: 50px;
    box-sizing: border-box;
    background-color: var(--semperred);
    border: none;
    color: white;
    font-weight: 600;
    padding: 20px 40px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    transition: all 0.25s linear;
  }
  :global(.floatingplaceholder) {
    -webkit-appearance: none;
    border-radius: 5px;
    height: 50px;
    /* border-bottom-right-radius: 0px; */
    /* border-top-right-radius: 0px; */
    min-width: 300px;
    box-sizing: border-box;
    border-color: #747b84;
    border-width: 1px;
    padding-left: 10px;
    padding-top: 10px;
  }
  :global(.floatingplaceholder:focus
      ~ .floating-label, .floatingplaceholder:not(:focus):valid
      ~ .floating-label) {
    top: 4px;
    bottom: 10px;
    left: 10px;
    font-size: 11px;
    opacity: 1;
  }
  .floating-label {
    position: absolute;
    pointer-events: none;
    left: 20px;
    top: 18px;
    transition: 0.2s ease all;
    color: #747b84;
  }
  .bottomcontainer {
    grid-area: bc;
  }
  .seehoweasycontainer {
    grid-area: sc;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .shetitle {
    width: 100%;
    text-align: center;
    font-weight: 600;
    color: black;
    font-size: 3em;
    padding-top: 50px;
    padding-bottom: 15px;
  }
  .shetext {
    width: 100%;
    text-align: center;
    font-size: 1em;
    line-height: 1.5em;
    color: var(--blueslate);
    padding-left: 20px;
    padding-right: 20px;
  }
  .shebuttonholder {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .shebuttonholder button {
    padding: 10px 30px;
    border: solid 1px;
    border-radius: 5px;
    cursor: pointer;
    border-color: var(--semperred);
    color: white;
    background-color: var(--semperred);
    width: 200px;
    transition: all 0.25s linear;
  }

  .footercontainer {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    grid-area: fc;
  }

  .mobileholder {
    grid-area: mh;
    text-align: center;
    padding-top: 50px;
    font-size: 2em;
    font-weight: bold;
    display: none;
  }

  /* @media (max-device-width: 1200px), (max-width: 1199px) {
    .navlinkscontainer {
      display: none;
    }
  }
   */
  @media (max-device-width: 1024px), (max-width: 1023px) {
    .navcontainer {
      display: none;
    }
    .navmobilecontainer {
      width: 100%;
      background-color: white;
      min-height: 72px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding-top: 30px;
    }
    .navmobilecontainerprogressmobile {
      border-bottom: 1px solid black;
    }
    .hamburgermenucontainer {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .mobilemenucontainer {
      display: flex;
      flex-direction: column;
      min-height: 200px;
      align-items: flex-end;
      min-width: 200px;
      /* width: 100vw; */
    }
    :global(.closedmenu) {
      display: none !important;
    }
    .hamburgermenu {
      width: 30px;
      height: 45px;
      position: relative;
      margin-right: 20px;
      /* margin: 50px auto; */
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: 0.5s ease-in-out;
      -moz-transition: 0.5s ease-in-out;
      -o-transition: 0.5s ease-in-out;
      transition: 0.5s ease-in-out;
      cursor: pointer;
    }
    .hamburgermenu span {
      display: block;
      position: absolute;
      height: 4px;
      width: 100%;
      background: var(--linkcolordark);
      border-radius: 3px;
      opacity: 1;
      left: 0;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: 0.25s ease-in-out;
      -moz-transition: 0.25s ease-in-out;
      -o-transition: 0.25s ease-in-out;
      transition: 0.25s ease-in-out;
    }
    .hamburgermenu span:nth-child(1) {
      top: 0px;
    }

    .hamburgermenu span:nth-child(2),
    .hamburgermenu span:nth-child(3) {
      top: 10px;
    }

    .hamburgermenu span:nth-child(4) {
      top: 20px;
    }

    :global(.hamburgermenu.open span:nth-child(1)) {
      top: 10px;
      width: 0%;
      left: 50%;
    }

    :global(.hamburgermenu.open span:nth-child(2)) {
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    :global(.hamburgermenu.open span:nth-child(3)) {
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }

    :global(.hamburgermenu.open span:nth-child(4)) {
      top: 18px;
      width: 0%;
      left: 50%;
    }

    .numbercontainer {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 150px;
      color: white;
      margin-right: 0;
    }
    .navlink {
      margin-right: 25px;
      text-align: right;
      margin-bottom: 30px;
    }
    .navlink:first-of-type {
      margin-top: 20px;
    }
    .phoneiconcontainer {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .phoneiconcontainer img {
      width: 1em;
      height: 1em;
      filter: invert(1);
    }
    .phonenumber {
      font-size: 1em;
      /* margin-left: 10px; */
    }
    .phonenumber a {
      text-decoration: none;
      color: white;
    }
    .numbercontainer {
      width: auto;
      /* margin-right: 40px; */
    }
    .phonenumber {
      font-size: 0.75em;
      margin-left: 0px;
    }

    .mobileapplynowbuttoncontainer {
      /* width: 100%;
        height: 32px; */
      width: 100%;
      /* height: 64px; */
      margin-top: 40px;
      margin-bottom: 40px;
      margin-right: 25px;
      display: flex;
      justify-content: flex-end;
    }
    .mobileapplynowbuttoncontainer a {
      width: 100%;
      text-decoration: none;
      text-align: center;
      background-color: var(--semperred);
      border: none;
      color: white;
      font-weight: 400;
      padding-bottom: 10px;
      padding-top: 10px;
      padding-left: 25px;
      padding-right: 25px;
      border-radius: 5px;
      cursor: pointer;
    }

    .logocontainer {
      margin-left: 40px;
    }
    .topcontainer {
        width: 100vw !important;
        min-width: 100vw !important;
        max-width: 100vw !important;
      grid-area: tc;
      /* background-image: url(/img/mobile_header_image2.png); */
      /* background-repeat: no-repeat; */
      /* min-height: 700px; */
      /* height: 154vw; */
      height: auto;
      /* width: 100%; */
      background-position: 0% 0%;
      background-size: 100% 100%;
      background-color: white;
    }
    .topcontainerprogressmobile {
      background-image: none;
    }
    .stepcontainer {
      width: 100%;
      height: auto;
      /* padding-left: 20px; */
      /* padding-right: 20px; */
      /* box-sizing: border; */
    }
    .stepcontainerprogressmobile {
      margin-top: 0px;
    }
    .csztitlecontainer,
    .csztextcontainer,
    .cszconditionscontainer {
      width: 90%;
      text-align: center;
      font-weight: 600;
      color: white;
      font-size: 2em;
      margin-top: 25px;
    }
    .csztextcontainer,
    .cszconditionscontainer {
      font-weight: normal;
      font-size: 1em;
      color: var(--blueslate);
    }
    .cszfieldcontainer {
      width: 100%;
    }
    .cszfieldcontainer input[type="text"] {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      /* min-width: 150px; */
      /* max-width: 100%; */
    }
    .cszfieldcontainer button {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      margin: 0 auto;
      margin-top: 20px;
      padding: 0;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      /* padding-left: 15px; */
      /* padding-right: 15px; */
    }
    .cszfieldcontainer {
      flex-direction: column;
      align-items: center;
      /* margin-bottom: 50px; */
    }
    .csztitlecontainer {
      margin-top: 15px;
      color: white !important;
      text-align: center !important;
      max-width: 300px;
      /* margin-left: -65px; */
      font-size: 2.2em;
    }
    .cszinputcontainer {
      min-width: 0;
      max-width: 100%;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }
    .maincontainer {
      /* width: 100%; */
      /* max-width: 100vw; */
      width: 100vw;
      max-width: 100vw !important;
      min-width: 100vw !important;
      margin-left: none;
      margin-right: none;
      /* width: 100vw; */

      /* margin-left: auto; */
      /* margin-right: auto; */
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      /* display: grid; */
      /* grid-template-columns: repeat(1, 1fr); */
      /* grid-template-rows: auto; */
      /* grid-template-areas: "bc" */
      /* "fc"; */
      /* gap: 20px; */
    }
    .maincontainerprogressmobile {
      background-color: white;
    }
    .footercontainer {
      margin-top: 50px;
    }
  }
</style>
